module.exports = __webpack_public_path__ + "static/testimonial-3079423a434bd5e69a846409042f2d38.svg";